<template>
    <div>
        <div class="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
            <div class="container">
                <div class="d-flex justify-content-between">
                    <!--begin::Page Title-->
                    <h1 class="mr-auto pages-title my-1 mr-5">ADMINISTRATEURS</h1>
                        <div class="d-flex">
                            <div class="mr-5 search-zone">
                                <div class="input-icon input-icon-right">
                                    <input wire:model.debounce.500ms="search" type="text" class="form-control basic_datatable_search_query" placeholder="Recherche ...">
                                    <span>
                                        <i class="flaticon2-search-1 icon-md"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column-fluid">
            <div class="container">
                <div v-if="loaded" class="card-body bg-white">
                    <div class="toolbar d-flex flex-end">
                        <button class="btn btn-info" data-toggle="modal" data-target="#ajouter_admin">Ajouter</button>
                    </div>
                    <div class="datatable datatable-default">
                        <table id="kt_table"
                            class="table table-dynamic-v1 basic_datatable">
                            <thead>
                                <tr>
                                    <th data-sortable="false">Nom Complet</th>
                                    <th data-sortable="false">Email</th>
                                    <th data-sortable="false">Rôle</th>
                                    <th data-sortable="false">Dernier connexion</th>
                                    <th data-sortable="false">Dernier action</th>
                                    <th data-sortable="false">action</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr v-for="admin in admins" :key="`admin${admin.id}`">
                                    <td>{{ admin.nom+' '+admin.prenom }}</td>
                                    <td>{{ admin.email }}</td>
                                    <td>{{ admin.role != null ? admin.role.libelle : 'aucun' }}</td>
                                    <td>{{ admin.dernier_connexion }}</td>
                                    <td>{{ admin.historique.length ? admin.historique[0].action : 'aucun' }}</td>
                                    <td>
                                        <a href="#" data-toggle="dropdown">
                                            <i class="material-icons">more_vert</i>
                                        </a>
                                        <div class="dropdown-menu">
                                            <a :href="`/administration/historique/filtrer?admin_id=${admin.id}`" class="dropdown-item">Historique</a>
                                            <a href="#" class="dropdown-item modifier" :data-id="admin.id"
                                                data-toggle="modal" data-target="#modifier_admin" @click="updateUser(admin.id)">Modifier</a>
                                            <a href="#" class="dropdown-item supprimer" :data-id="admin.id"
                                                data-toggle="modal" data-target="#supprimer_admin" @click="deleteUser(admin.id)">Supprimer</a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
                <div v-if="loaded == 0" class="card-body bg-white">
                    <div class="d-flex justify-content-center align-center">
                        <div class="spinner-border text-info" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Ajouter un admin -->
        <div class="modal" role="dialog" id="ajouter_admin">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <form :action="store_url" method="post">
                        <input type="hidden" name="_token" :value="token">
                        <div class="modal-header">
                            <h5 class="modal-title">Ajouter un admin</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group bmd-form-group">
                                        <label class="bmd-label-floating">Nom</label>
                                        <input type="text" name="nom" class="form-control" required>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group bmd-form-group">
                                        <label class="bmd-label-floating">Prénom</label>
                                        <input type="text" name="prenom" class="form-control" required>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group bmd-form-group">
                                <label for="" class="bmd-label-floating">Email</label>
                                <input type="email" name="email" class="form-control" required>
                            </div>
                            <select name="role_id" class="selectpicker col-12 px-0" title="Role"
                                data-style="select-with-transition" required v-model="role">
                                <option v-for="role in roles" :key="`role${role.id}`" :value="role.id">{{ role.libelle }}</option>
                            </select>
                            <div v-show="role == 2 || role == 3 || role == 4">
                                <select name="college_id" class="selectpicker col-12 px-0" title="college"
                                    data-style="select-with-transition" v-model="college">
                                    <option v-for="college in colleges" :key="`college${college.id}`" :value="college.id">
                                        {{ college.nom }}</option>
                                </select>
                            </div>
                            <div v-show="role == 2 || role == 3">
                                <select name="etablissement_id" class="selectpicker col-12 px-0" title="etablissement"
                                    data-style="select-with-transition">
                                    <option v-for="etablissement in etablissements"
                                        :key="`etablissement${etablissement.id}`" :value="etablissement.id">
                                        {{ etablissement.nom }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="modal-footer mt-3 d-flex justify-space-between">
                            <button data-dismiss="modal" class="btn btn-outline-danger">Annuler</button>
                            <button type="submit" class="btn btn-info">Ajouter</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Modifier un admin -->
        <div class="modal" role="dialog" id="modifier_admin">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <form :action="update_url" method="post">
                        <input type="hidden" name="_token" :value="token">
                        <input type="hidden" name="_method" value="PUT">
                        <div class="modal-header">
                            <h5 class="modal-title">Modifier l'admin</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group bmd-form-group">
                                        <label class="bmd-label-floating">Nom</label>
                                        <input type="text" name="nom" class="form-control" v-model="nom" required>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group bmd-form-group">
                                        <label class="bmd-label-floating">Prénom</label>
                                        <input type="text" name="prenom" class="form-control" v-model="prenom" required>
                                    </div>
                                </div>
                            </div>
                            <select name="role_id" class="selectpicker col-12 px-0" title="Role"
                                data-style="select-with-transition" required v-model="role">
                                <option v-for="role in roles" :key="`role${role.id}`" :value="role.id">{{ role.libelle }}</option>
                            </select>
                            <div v-show="role == 2 || role == 3 || role == 4">
                                <select name="college_id" class="selectpicker col-12 px-0" title="college"
                                    data-style="select-with-transition" v-model="college">
                                    <option v-for="college in colleges" :key="`${college.id}`" :value="college.id">{{ college.nom }}</option>
                                </select>
                            </div>
                            <div v-show="role == 2 || role == 3">
                                <select name="etablissement_id" class="selectpicker col-12 px-0" title="etablissement"
                                    data-style="select-with-transition" v-model="etablissement">
                                    <option v-for="etablissement in etablissements" :key="`${etablissement.id}`" :value="etablissement.id">
                                        {{ etablissement.nom }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="modal-footer mt-3 d-flex justify-space-between">
                            <button data-dismiss="modal" class="btn btn-outline-danger">Annuler</button>
                            <button type="submit" class="btn btn-info">Modifier</button>
                        </div>
                    </form>

                </div>
            </div>
        </div>

        <!-- Supprimer un admin  -->

        <div class="modal modal-mini" role="dialog" id="supprimer_admin">
            <div class="modal-dialog modal-small">
                <div class="modal-content">
                    <form :action="delete_url" method="post">
                        <input type="hidden" name="_token" :value="token">
                        <input type="hidden" name="_method" value="DELETE">
                        <div class="modal-header">
                            <h5 class="modal-title"></h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <h4 class="text-danger">Attention !</h4>
                            <p>Vous êtes sûr de supprimer cet admin ?</p>
                        </div>
                        <div class="modal-footer mt-3 d-flex justify-space-between">
                            <button data-dismiss="modal" class="btn btn-success">Annuler</button>
                            <button type="submit" class="btn btn-outline-danger">Supprimer</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            api_token: String,
            store_url: String,
            update_url: String,
            delete_url: String,
        },
        data() {
            return {
                token: null,
                agresso: null,
                nom: null,
                prenom: null,
                role: null,
                etablissement: null,
                college: null,
                loaded: 0,
                admins: [],
                etablissements: [],
                colleges: [],
                roles: [],
                config: {
                    'headers': {
                        'Authorization': 'Bearer '+this.api_token
                    }
                }
            }
        },
        watch: {
            college: function(val) {
                if(this.college) {
                    axios.get(`/api/etablissements/${this.college}`)
                    .then(res => {
                        this.etablissements = res.data;
                    }).finally(() => {
                        $('.selectpicker').selectpicker('refresh');
                    });
                }
            }
        },
        methods: {
            updateUser(id) {
                var url = this.update_url.replace("ID", id);
                $("#modifier_admin form").attr('action', url);

                axios.get(`/api/admin/${id}`, this.config)
                .then(res => {
                    var user = res.data;
                    this.nom = user.nom;
                    this.role = user.role_id;
                    this.prenom = user.prenom;
                    this.etablissement = user.etablissement_id;
                    this.college = user.college_id;
                    this.agresso = user.agresso;
                    $('#modifier_admin .bmd-form-group').addClass('is-filled');
                }).finally(() => {
                    $('.selectpicker').selectpicker('refresh');
                });
            },
            deleteUser(id) {
                var url = this.delete_url.replace("ID", id);
                $("#supprimer_admin form").attr('action', url);
            }
        },
        created() {
            this.token = $('meta[name="csrf-token"]').attr('content');
            axios.all([
                axios.get('/api/admin', this.config),
                axios.get('/api/etablissements', this.config),
                axios.get('/api/colleges', this.config),
                axios.get('/api/roles', this.config)
            ]).then((response) => {
                this.admins = response[0].data;
                this.etablissements = response[1].data;
                this.colleges = response[2].data;
                this.roles = response[3].data;
                this.loaded = 1;
            }).finally(() => {
                $('.selectpicker').selectpicker('refresh');
            });
        },
    }

</script>

<style scoped>
    .align-center {
        align-items: center;
    }
</style>
